import { connect } from "react-redux";
import { withFormik } from "formik";
import {
  ownerPortfoliosSelectorWithPermission,
  selectedOwnerPortfolioSelectorWithPermission,
} from "selectors/portfolio";

import withMaps from "components/hoc/withMaps";
import assetLeadName from "utils/assetLeads/name";

import AssetLeadCreateForm from "./AssetLeadCreateForm";
import validationSchema from "./validationSchema";

const form = withFormik({
  displayName: "assetLead",
  enableReinitialize: true,
  mapPropsToValues: ({ currentUser, portfolio }) => ({
    pointPerson: {
      id: currentUser.id,
    },
    portfolio,
  }),
  handleSubmit: (values, { props: { onSubmit }, setSubmitting }) =>
    onSubmit({
      ...values,
      portfolioID: values.portfolio.id,
      portfolio: undefined,
      pointPersonID: values.pointPerson.id,
      pointPerson: null,
      countryID: values.country ? values.country.id : undefined,
      country: undefined,
      name: assetLeadName(values),
    }).finally(() => setSubmitting(false)),
  validationSchema: () => validationSchema,
})(AssetLeadCreateForm);

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  isSubmitting: state.loading.assetLead,
  portfolio: selectedOwnerPortfolioSelectorWithPermission("asset_leads")(state),
  portfolios: ownerPortfoliosSelectorWithPermission("asset_leads")(state),
});

export default withMaps(connect(mapStateToProps)(form));
